import React from 'react'
import { ProductPermission, ProductSector } from 'api'
import { ProductsPanelGridRow } from './ProductsPanelGridModel'
import { DefaultCellContentWrapper } from 'view/components/datagrid/renderers'
import { TextFlagButton } from 'view/components/buttons'
import { TextFlagState } from 'view/components/buttons/TextFlagButton'
import { Locale, Translation } from 'locale'

interface ProductPermissionButtonsProps {
  row: ProductsPanelGridRow
  hideViewPermission?: boolean
  hideWritePermission?: boolean
  disabled?: boolean
  onUpdatePermissions: (productSectors: ProductSector[], permission: ProductPermission | null) => void
}

export class ProductPermissionButtons extends React.Component<ProductPermissionButtonsProps> {
  render() {
    const { row, hideViewPermission, hideWritePermission, disabled } = this.props

    return (
      <DefaultCellContentWrapper>
        {!hideViewPermission && (
          <TextFlagButton
            dataTestId={'ProductPermissionButtons-TextFlagButton-View'}
            state={row.permission === ProductPermission.VIEW ? TextFlagState.On : TextFlagState.Off}
            onClick={this.onClickView}
            disabled={disabled}>
            {Locale.translate(Translation.TC_VIEW)}
          </TextFlagButton>
        )}
        {!hideWritePermission && (
          <TextFlagButton
            dataTestId={'ProductPermissionButtons-TextFlagButton-Write'}
            state={row.permission === ProductPermission.WRITE ? TextFlagState.On : TextFlagState.Off}
            onClick={this.onClickWrite}
            disabled={disabled}>
            {Locale.translate(Translation.TC_WRITE)}
          </TextFlagButton>
        )}
        <TextFlagButton
          dataTestId={'ProductPermissionButtons-TextFlagButton-Trade'}
          state={row.permission === ProductPermission.TRADE ? TextFlagState.On : TextFlagState.Off}
          onClick={this.onClickTrade}
          disabled={disabled}>
          {Locale.translate(Translation.TC_TRADE)}
        </TextFlagButton>
      </DefaultCellContentWrapper>
    )
  }

  private togglePermission = (permission: ProductPermission) => {
    if (this.props.row.permission === permission) {
      this.props.onUpdatePermissions([this.props.row.productSector], null)
    } else {
      this.props.onUpdatePermissions([this.props.row.productSector], permission)
    }
  }

  private onClickView = () => {
    this.togglePermission(ProductPermission.VIEW)
  }

  private onClickWrite = () => {
    this.togglePermission(ProductPermission.WRITE)
  }

  private onClickTrade = () => {
    this.togglePermission(ProductPermission.TRADE)
  }
}
